import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationIcon from "../../../Img/notification-icon.svg";
import Cookies from "js-cookie";
import {
  notificationSubscribe,
  setAllowNotificationToggle,
} from "redux/reducers/Notification/NotificationSlice";
import { Button } from "antd";

const NotificationEnablePopup = ({ closeToast, data }) => {
  const dispatch = useDispatch();

  const { selectedLocation } = useSelector(({ role }) => role);

  const handleAllowPermission = useCallback(async () => {
    const res = await dispatch(
      notificationSubscribe({
        location_id: selectedLocation,
      })
    );

    if (res) {
      dispatch(setAllowNotificationToggle(true));
      closeToast();
    }
  }, [closeToast, dispatch]);

  return (
    <div
      className="d-flex flex-column w-100 notification-modal"
      onClick={(e) => e.stopPropagation()} // Prevent toast from closing when clicking inside
    >
      <h3 className="d-flex align-items-center justify-content-center">
        <img src={NotificationIcon} alt="" />
      </h3>

      <div className="mt-2">
        <p className="text-center notification_content">{data.content}</p>

        <div className="d-flex justify-content-center gap-2">
          {/* <button
            onClick={handleAllowPermission}
            className="btn_primary btn btn-primary"
          >
            Allow
          </button> */}

          <Button className="btn_primary" onClick={handleAllowPermission}>
            Allow
          </Button>

          {/* <button
            onClick={() => {
              Cookies.set("notificationPermissionNotAllow", true, {
                expires: 12,
              });
              closeToast();
            }}
            className="btn_border_dark "
          >
            Dismiss
          </button> */}

          <Button
            className="btn_primary"
            onClick={() => {
              Cookies.set("notificationPermissionNotAllow", true, {
                expires: 12,
              });
              closeToast();
            }}
          >
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(NotificationEnablePopup);
